import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  TextInput,
  FormHeading,
  Flex,
  Label,
  FormGroup,
  Button,
  Divider,
  Span,
  Select
} from '@ubisend/pulse-components';
import { useRows, Rows } from '@ubisend/pulse-hooks';

import { useAuth } from '../../hooks/index';
import { Auth } from './Auth/index';
import HeaderSelect from './HeaderSelect';

const IntegrationDetails = ({
  handleSubmit,
  initialName = '',
  initialType = 'rest',
  initialAuth,
  initialBaseUrl = '',
  initialHeaders,
  initialShowAuth = true
}) => {
  const [name, setName] = useState(initialName);
  const auth = useAuth(initialAuth);
  const [baseUrl, setBaseUrl] = useState(initialBaseUrl);
  const headers = useRows(initialHeaders);
  const [showAuth, setShowAuth] = useState(initialShowAuth);
  const [type, setType] = useState(initialType);

  const valid =
    name.length > 3 && auth.valid && baseUrl.length > 5 && headers.valid;

  const onSubmit = event => {
    event.preventDefault();

    if (!valid) {
      return false;
    }

    handleSubmit({
      name,
      type,
      base_url: baseUrl,
      headers: headers.rows,
      ...(showAuth && { authorization: auth.form })
    });
  };

  const handleNameChange = event => {
    setName(event.target.value);
  };

  const handleTypeChange = option => {
    setType(option.value);
  };

  const handleBaseUrlChange = event => {
    setBaseUrl(event.target.value);
  };

  const handleShowAuth = () => setShowAuth(true);

  const options = [
    { value: 'rest', label: 'REST' },
    { value: 'soap', label: 'SOAP' }
  ];

  return (
    <form onSubmit={onSubmit}>
      <FormHeading>Integration Details</FormHeading>
      <FormGroup>
        <Label htmlFor="name">Integration Name</Label>
        <TextInput
          id="name"
          placeholder="Hubspot"
          value={name}
          onChange={handleNameChange}
        />
      </FormGroup>
      <FormGroup>
        <Label htmlFor="url">Base URL</Label>
        <TextInput
          id="url"
          placeholder="https://api.example.com"
          value={baseUrl}
          onChange={handleBaseUrlChange}
        />
      </FormGroup>
      <FormGroup>
        <Label htmlFor="rest-or-soap-select">Api Type</Label>
        <Select
          id="rest-or-soap-select"
          options={options}
          value={options.find(option => option.value === type)}
          onChange={handleTypeChange}
        />
      </FormGroup>
      <Divider />
      <Flex between>
        <FormHeading>Authorization</FormHeading>
        {!showAuth && (
          <Flex top>
            <Button onClick={handleShowAuth}>Change Credentials</Button>
          </Flex>
        )}
      </Flex>
      <FormGroup>
        {showAuth ? (
          <Auth {...auth} />
        ) : (
          <Span>Authorization credentials have already been set</Span>
        )}
      </FormGroup>
      <Divider />
      <FormHeading>Headers</FormHeading>
      <FormGroup>
        <Rows {...headers} KeyInput={HeaderSelect} />
      </FormGroup>
      <Flex right>
        <Button disabled={!valid} type="submit" variant="primary">
          Save
        </Button>
      </Flex>
    </form>
  );
};

IntegrationDetails.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  initialName: PropTypes.string,
  initialAuth: PropTypes.shape({
    type: PropTypes.string,
    credentials: PropTypes.object
  }),
  initialType: PropTypes.string,
  initialBaseUrl: PropTypes.string,
  initialHeaders: PropTypes.arrayOf(
    PropTypes.shape({ key: PropTypes.string, value: PropTypes.string })
  ),
  initialShowAuth: PropTypes.bool
};

export default IntegrationDetails;
